// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.post-list {
  display: flex;
  flex-direction: column;
  gap: 40px;
  padding: 20px 0;
}

.post {
  padding: 20px 0;
  border-bottom: 2px solid rgba(172,176,177,255);
  transition: background-color 0.2s;
}

.post:hover {
  background-color: rgba(0, 0, 0, 0.05);
}

.post-content {
  max-width: 1200px;
  margin: 0 auto;
}

.post-title {
  font-size: 52px;
  margin-bottom: 10px;
  color: #323232;
  font-family: 'AlternateGot', Arial, sans-serif;
}

.post-date {
  color: #676a6a;
  margin-bottom: 15px;
  font-weight: bold;
  font-family: 'AlternateGot', Arial, sans-serif;
  font-size: 32px;
}

.post-body {
  font-size: 32px;
  line-height: 1.5;
  color: #676a6a;
  font-family: 'AlternateGot', Arial, sans-serif;
}

.post-paragraph {
  margin-bottom: 1.5rem;
}

.post-footnote {
  margin-top: 2rem;
  margin-bottom: 1rem;
  font-size: 24px;
  color: #999999;
  font-style: italic;
  line-height: 1.4;
}

.post-center {
  text-align: center;
}

.post-left {
  text-align: left;
}

/* Link styling */
.post-link {
  color: #4a90d9;
  text-decoration: underline;
  transition: color 0.2s ease;
  word-break: break-all;
}

.post-link:hover {
  color: #2d6cb5;
}

.post-link:visited {
  color: #7b68b8;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .post {
    padding: 1.5rem;
  }
  
  .post-title {
    font-size: 36px;
  }
  
  .post-date {
    font-size: 24px;
  }
  
  .post-body {
    font-size: 24px;
  }
  
  .post-footnote {
    font-size: 18px;
  }
}

`, "",{"version":3,"sources":["webpack://./src/styles/Post.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,8CAA8C;EAC9C,iCAAiC;AACnC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,8CAA8C;AAChD;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,8CAA8C;EAC9C,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,8CAA8C;AAChD;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,cAAc;EACd,0BAA0B;EAC1B,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".post-list {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 40px;\r\n  padding: 20px 0;\r\n}\r\n\r\n.post {\r\n  padding: 20px 0;\r\n  border-bottom: 2px solid rgba(172,176,177,255);\r\n  transition: background-color 0.2s;\r\n}\r\n\r\n.post:hover {\r\n  background-color: rgba(0, 0, 0, 0.05);\r\n}\r\n\r\n.post-content {\r\n  max-width: 1200px;\r\n  margin: 0 auto;\r\n}\r\n\r\n.post-title {\r\n  font-size: 52px;\r\n  margin-bottom: 10px;\r\n  color: #323232;\r\n  font-family: 'AlternateGot', Arial, sans-serif;\r\n}\r\n\r\n.post-date {\r\n  color: #676a6a;\r\n  margin-bottom: 15px;\r\n  font-weight: bold;\r\n  font-family: 'AlternateGot', Arial, sans-serif;\r\n  font-size: 32px;\r\n}\r\n\r\n.post-body {\r\n  font-size: 32px;\r\n  line-height: 1.5;\r\n  color: #676a6a;\r\n  font-family: 'AlternateGot', Arial, sans-serif;\r\n}\r\n\r\n.post-paragraph {\r\n  margin-bottom: 1.5rem;\r\n}\r\n\r\n.post-footnote {\r\n  margin-top: 2rem;\r\n  margin-bottom: 1rem;\r\n  font-size: 24px;\r\n  color: #999999;\r\n  font-style: italic;\r\n  line-height: 1.4;\r\n}\r\n\r\n.post-center {\r\n  text-align: center;\r\n}\r\n\r\n.post-left {\r\n  text-align: left;\r\n}\r\n\r\n/* Link styling */\r\n.post-link {\r\n  color: #4a90d9;\r\n  text-decoration: underline;\r\n  transition: color 0.2s ease;\r\n  word-break: break-all;\r\n}\r\n\r\n.post-link:hover {\r\n  color: #2d6cb5;\r\n}\r\n\r\n.post-link:visited {\r\n  color: #7b68b8;\r\n}\r\n\r\n/* Responsive adjustments */\r\n@media (max-width: 768px) {\r\n  .post {\r\n    padding: 1.5rem;\r\n  }\r\n  \r\n  .post-title {\r\n    font-size: 36px;\r\n  }\r\n  \r\n  .post-date {\r\n    font-size: 24px;\r\n  }\r\n  \r\n  .post-body {\r\n    font-size: 24px;\r\n  }\r\n  \r\n  .post-footnote {\r\n    font-size: 18px;\r\n  }\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
